import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { Observable } from 'rxjs';
import { FilterResult } from '../../../repository.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'wncm-form-control-checkboxlist',
	templateUrl: './form-control-checkboxlist.component.html',
	styleUrls: ['./form-control-checkboxlist.component.scss']
})
export class FormControlCheckboxlistComponent extends FormControlComponent implements OnInit {
	@Input()
	from: Observable<FilterResult<any>>;

	@Input()
	label: string;

	@Input()
	value = 'id';

	@Input()
	detailButton = false;

	@Input()
	inline = false;

	@Input()
	disabled = false;

	@Input()
	displaySelectAll = false;

	@Input()
	canSelect = true;

	@Output()
	detailsClicked: EventEmitter<any> = new EventEmitter<any>();

	items: FilterResult<any>;
	options = [];
	selected = [];

	constructor(private translate: TranslateService) {
		super();
	}

	// private refreshOptions() {
	//   this.options = this.items.items ? this.items.items.map<SelectOption>(i =>
	//     <SelectOption>{
	//       id: i.id,
	//       label: this.label === 'translationKey' ? this.translate.instant(i[this.label]) : i[this.label]
	//     }) : [];
	// }

	ngOnInit() {
		this.from.subscribe((items) => {
			if (!items) {
				items = {
					items: [],
					total: 0
				};
			}

			this.items = items;

			this.items.items.forEach((element) => {
				element[this.label] =
					this.label === 'translationKey' ? this.translate.instant(element[this.label]) : element[this.label];
			});
		});

		this.selected = this.control.value || [];

		this.control.valueChanges.subscribe((value) => {
			this.selected = value || [];
		});
	}

	checkChanged(evt: MatCheckboxChange) {
		if (evt.checked) {
			const elmt = evt.source.value;

			this.selected.push(elmt);
		} else {
			const pos = this.position(evt.source.value);
			if (pos > -1) {
				this.selected.splice(pos, 1);
			}
		}
		this.control.setValue(this.selected);
	}

	checkAll() {
		for (let i = 0; i < this.items.items.length; i++) {
			const item = this.items.items[i];
			const pos = this.position(item[this.value]);
			if (pos < 0) {
				const elmt = item[this.value];
				this.selected.push(elmt);
			}
		}
	}

	uncheckAll() {
		for (let i = 0; i < this.items.items.length; i++) {
			const item = this.items.items[i];
			const pos = this.position(item[this.value]);
			if (pos >= 0) {
				this.selected.splice(pos, 1);
			}
		}
	}

	position(id): number {
		for (let idx = 0; idx < this.selected.length; idx++) {
			if (this.selected[idx] == id) {
				return idx;
			}
		}

		return -1;
	}

	detailAsked(item: any) {
		this.detailsClicked.emit(item);
	}
}
